import { render, staticRenderFns } from "./WhitelistedAddresses.vue?vue&type=template&id=9280eda8&scoped=true&"
import script from "./WhitelistedAddresses.vue?vue&type=script&lang=js&"
export * from "./WhitelistedAddresses.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistedAddresses.vue?vue&type=style&index=0&id=9280eda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9280eda8",
  null
  
)

export default component.exports